import { useState } from "react";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { AppModal, bodyTextSx } from "global/components/AppModal";

interface LogoutConfirmDialogProps {
  isOpen: boolean;
  isLoggingOut: boolean;
  onCancel: () => void;
  onConfirm: (alsoSignOutSso: boolean) => void;
}

const LogoutConfirmDialog = ({
  isOpen,
  isLoggingOut,
  onCancel,
  onConfirm,
}: LogoutConfirmDialogProps) => {
  const [alsoSignOutSso, setAlsoSignOutSso] = useState(false);

  return (
    <AppModal
      open={isOpen}
      onClose={onCancel}
      title="Log out"
      tone="neutral"
      size="sm"
      // Signing out mid-request would strand the SSO round trip, so the shell
      // stays put until it settles — as it did behind `persistOnClickOutside`.
      busy={isLoggingOut}
      disableBackdropClose
      primaryLabel="Log out"
      onPrimary={() => onConfirm(alsoSignOutSso)}
      primaryLoading={isLoggingOut}
      cancelLabel="Cancel"
      onCancel={onCancel}
    >
      <Stack spacing={1}>
        <Typography sx={bodyTextSx}>
          Are you sure you want to log out?
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={alsoSignOutSso}
              onChange={(event) => setAlsoSignOutSso(event.target.checked)}
              disabled={isLoggingOut}
            />
          }
          label="Also sign out of your organization's SSO"
        />
      </Stack>
    </AppModal>
  );
};

export default LogoutConfirmDialog;
